export default __webpack_public_path__ + "static/media/logoTramitec.3510104a.png";